import { useEffect, useState } from "react"

import { CurrencyCode } from "../../currencies"
import { catalogService } from "./service"
import { CatalogItem } from "./types"
import useCatalogGatsbyData from "./use-catalog-gatsby-data"

const useCatalogData = () => {
  const { catalogInitial, currencyInitial } = useCatalogGatsbyData()
  const [catalogItems, setCatalogItems] = useState<CatalogItem[] | undefined>(
    catalogInitial,
  )

  const [catalogCurrencies, setCatalogCurrencies] = useState<
    CurrencyCode[] | undefined
  >(currencyInitial)
  useEffect(() => {
    catalogService.getCatalog().then(({ currencies, catalog }) => {
      setCatalogCurrencies(currencies)
      setCatalogItems(catalog)
    })
  }, [])

  return {
    catalogItems,
    catalogCurrencies,
  }
}

export default useCatalogData
